import { SVGProps } from 'react'

const PricingIllustration = (props: SVGProps<SVGSVGElement>) => {
  return (
    <svg
      width="268"
      height="268"
      viewBox="0 0 268 268"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M180.09 218.634C175.231 210.346 179.946 196.545 185.719 188.465C192.458 179.032 197.934 181.183 202.605 173.438C211.301 159.019 195.886 145.648 203.503 130.412C209.729 117.956 222.394 122.165 228.661 108.058C233.184 97.8779 228.764 90.7931 235.62 83.2298C236.206 82.5832 242.628 75.701 250.427 76.9475C258.298 78.2057 262.969 87.009 264.497 93.0872C267.322 104.322 259.829 107.922 258.29 122.47C256.194 142.276 268.843 147.327 264.285 161.592C260.522 173.371 251.029 172.644 247.116 185.787C243.482 197.992 250.347 203.055 247.116 211.031C239.682 229.382 190.002 235.538 180.09 218.634Z"
        fill="url(#paint0_linear_10922_90677)"
      />
      <mask
        id="mask0_10922_90677"
        maskUnits="userSpaceOnUse"
        x="178"
        y="76"
        width="88"
        height="153"
      >
        <path
          d="M180.086 218.642C175.227 210.354 179.942 196.553 185.715 188.473C192.455 179.039 197.93 181.191 202.601 173.446C211.297 159.027 195.882 145.656 203.499 130.419C209.725 117.964 222.39 122.173 228.657 108.066C233.18 97.8858 228.76 90.8009 235.616 83.2376C236.202 82.591 242.624 75.7088 250.423 76.9553C258.294 78.2135 262.965 87.0168 264.493 93.095C267.318 104.33 259.825 107.93 258.286 122.478C256.19 142.284 268.839 147.335 264.281 161.6C260.518 173.379 251.025 172.651 247.112 185.795C243.478 198 250.343 203.062 247.112 211.039C239.678 229.39 189.998 235.546 180.086 218.642Z"
          fill="white"
        />
      </mask>
      <g mask="url(#mask0_10922_90677)">
        <path
          opacity="0.7"
          d="M186.674 231.694C186.59 231.694 186.518 231.631 186.509 231.546C186.499 231.455 186.565 231.373 186.656 231.363C195.089 230.47 202.964 227.853 210.063 223.584C216.787 219.541 223.739 215.359 226.824 207.663C229.155 201.845 227.871 197.557 226.246 192.128C224.661 186.836 222.689 180.25 223.778 170.185C224.4 164.438 225.174 157.285 230.155 150.516C233.058 146.572 235.874 144.883 238.359 143.393C240.955 141.836 243.007 140.606 244.203 137.315C246.157 131.942 244.873 127.32 243.387 121.969C242.469 118.66 241.519 115.239 241.159 111.177C240.145 99.7412 245.543 87.446 257.203 74.6324C257.265 74.5646 257.37 74.5596 257.438 74.6213C257.506 74.6832 257.511 74.7882 257.449 74.8561C245.854 87.5981 240.485 99.8083 241.49 111.147C241.847 115.18 242.793 118.586 243.708 121.88C245.209 127.286 246.505 131.956 244.515 137.429C243.279 140.83 241.078 142.15 238.529 143.678C236.072 145.152 233.286 146.823 230.422 150.713C225.494 157.41 224.726 164.513 224.108 170.221C223.027 180.219 224.988 186.769 226.564 192.032C228.208 197.524 229.507 201.861 227.132 207.786C224.006 215.587 217.005 219.797 210.234 223.869C203.093 228.163 195.172 230.796 186.692 231.694C186.686 231.694 186.68 231.694 186.674 231.694Z"
          fill="white"
        />
        <path
          opacity="0.7"
          d="M228.174 154.128C228.11 154.128 228.049 154.091 228.022 154.029C221.216 138.62 220.146 126.691 220.447 119.396C220.774 111.479 222.745 107.147 222.766 107.104C222.804 107.021 222.904 106.985 222.986 107.023C223.069 107.062 223.105 107.161 223.067 107.244C223.047 107.286 221.1 111.574 220.778 119.433C220.482 126.688 221.551 138.556 228.326 153.895C228.363 153.978 228.325 154.077 228.241 154.114C228.219 154.123 228.196 154.128 228.174 154.128Z"
          fill="white"
        />
        <path
          opacity="0.7"
          d="M223.686 178.556C223.612 178.556 223.545 178.507 223.525 178.432C223.502 178.343 223.554 178.252 223.643 178.229C243.197 173.04 252.821 161.736 257.453 153.167C262.469 143.884 262.87 135.732 262.873 135.651C262.877 135.562 262.951 135.492 263.039 135.492C263.042 135.492 263.044 135.492 263.046 135.492C263.138 135.496 263.209 135.574 263.205 135.665C263.202 135.747 262.798 143.976 257.745 153.325C253.083 161.951 243.397 173.33 223.728 178.55C223.714 178.554 223.7 178.556 223.686 178.556Z"
          fill="white"
        />
        <path
          opacity="0.7"
          d="M217.62 219.559C217.582 219.559 217.543 219.546 217.512 219.519C202.878 206.915 198.152 193.912 196.765 185.223C195.261 175.8 197.251 169.268 197.271 169.203C197.299 169.115 197.39 169.066 197.479 169.094C197.567 169.121 197.616 169.214 197.589 169.302C197.568 169.366 195.599 175.838 197.096 185.189C198.478 193.818 203.178 206.735 217.729 219.267C217.798 219.327 217.806 219.432 217.746 219.502C217.714 219.54 217.667 219.559 217.62 219.559Z"
          fill="white"
        />
        <path
          opacity="0.7"
          d="M241.534 109.368C241.469 109.368 241.407 109.33 241.38 109.267C241.345 109.182 241.384 109.085 241.469 109.049C255.616 103.064 261.636 92.8639 264.195 85.3614C266.971 77.2242 266.391 70.4132 266.385 70.3453C266.376 70.254 266.444 70.1732 266.535 70.1648C266.626 70.1561 266.707 70.2236 266.716 70.3151C266.722 70.3836 267.309 77.2538 264.515 85.4556C261.935 93.027 255.865 103.319 241.598 109.355C241.577 109.364 241.555 109.368 241.534 109.368Z"
          fill="white"
        />
      </g>
      <path
        d="M188.17 188.178C178.169 183.922 172.988 171.514 172.657 161.67C172.147 146.476 183.412 144.022 184.766 127.694C186.206 110.33 173.994 106.747 176.058 90.2821C177.949 75.2018 188.449 76.1696 193.061 58.398C197.699 40.5273 188.897 33.1682 196.311 18.6632C197.725 15.8979 203.536 4.52841 213.72 3.78076C222.241 3.15518 229.94 10.2497 233.171 17.0236C236.824 24.6836 233.232 28.7204 233.585 42.2678C234.066 60.7755 240.971 60.9736 239.718 73.5443C238.042 90.3443 225.554 93.8467 227.064 107.297C228.079 116.342 234.405 116.36 238.095 126.957C243.369 142.1 236.898 160.568 226.549 172.213C225.189 173.744 205.372 195.5 188.17 188.178Z"
        fill="url(#paint1_linear_10922_90677)"
      />
      <path
        d="M188.17 188.178C178.169 183.922 172.988 171.514 172.657 161.67C172.147 146.476 183.412 144.022 184.766 127.694C186.206 110.33 173.994 106.747 176.058 90.2821C177.949 75.2018 188.449 76.1696 193.061 58.398C197.699 40.5273 188.897 33.1682 196.311 18.6632C197.725 15.8979 203.536 4.52841 213.72 3.78076C222.241 3.15518 229.94 10.2497 233.171 17.0236C236.824 24.6836 233.232 28.7204 233.585 42.2678C234.066 60.7755 240.971 60.9736 239.718 73.5443C238.042 90.3443 225.554 93.8467 227.064 107.297C228.079 116.342 234.405 116.36 238.095 126.957C243.369 142.1 236.898 160.568 226.549 172.213C225.189 173.744 205.372 195.5 188.17 188.178Z"
        fill="url(#paint2_linear_10922_90677)"
      />
      <mask
        id="mask1_10922_90677"
        maskUnits="userSpaceOnUse"
        x="172"
        y="3"
        width="68"
        height="187"
      >
        <path
          d="M188.17 188.178C178.169 183.922 172.988 171.514 172.657 161.67C172.147 146.476 183.412 144.022 184.766 127.694C186.206 110.33 173.994 106.747 176.058 90.2821C177.949 75.2018 188.449 76.1696 193.061 58.398C197.699 40.5273 188.897 33.1682 196.311 18.6632C197.725 15.8979 203.536 4.52841 213.72 3.78076C222.241 3.15518 229.94 10.2497 233.171 17.0236C236.824 24.6836 233.232 28.7204 233.585 42.2678C234.066 60.7755 240.971 60.9736 239.718 73.5443C238.042 90.3443 225.554 93.8467 227.064 107.297C228.079 116.342 234.405 116.36 238.095 126.957C243.369 142.1 236.898 160.568 226.549 172.213C225.189 173.744 205.372 195.5 188.17 188.178Z"
          fill="white"
        />
      </mask>
      <g mask="url(#mask1_10922_90677)">
        <path
          opacity="0.7"
          d="M194.088 193.518C194.047 193.518 194.006 193.503 193.974 193.473C193.907 193.41 193.904 193.305 193.967 193.238C205.298 181.165 210.869 168.989 210.523 157.051C210.36 151.398 208.92 148.028 207.253 144.125C205.578 140.204 203.679 135.76 202.404 127.884C199.89 112.355 201.188 98.2898 206.26 86.078C209.045 79.3715 211.911 75.8646 214.215 73.0468C216.834 69.8418 218.903 67.3102 219.732 61.6733C220.699 55.1013 218.882 50.7225 216.778 45.6523C215.001 41.371 212.987 36.5186 212.357 29.4636C211.43 19.0844 213.091 8.19827 217.294 -2.89255C217.326 -2.97831 217.422 -3.02188 217.508 -2.98906C217.594 -2.95661 217.637 -2.86065 217.604 -2.7748C213.42 8.26859 211.766 19.1053 212.689 29.434C213.314 36.4381 215.317 41.2656 217.085 45.5249C219.208 50.6407 221.041 55.0588 220.061 61.7217C219.219 67.4493 217.124 70.0123 214.472 73.2571C212.183 76.0581 209.333 79.5439 206.567 86.2054C201.519 98.3594 200.228 112.364 202.732 127.831C204.001 135.667 205.891 140.091 207.558 143.994C209.239 147.928 210.69 151.326 210.856 157.041C211.204 169.071 205.603 181.326 194.209 193.466C194.177 193.501 194.132 193.518 194.088 193.518Z"
          fill="white"
        />
        <path
          opacity="0.7"
          d="M219.564 52.631C219.54 52.631 219.516 52.6258 219.493 52.6149C207.624 46.9762 200.416 35.9004 196.459 27.6018C192.176 18.6176 190.674 10.8604 190.659 10.7831C190.642 10.6929 190.701 10.606 190.792 10.5889C190.881 10.5718 190.969 10.6309 190.986 10.7212C191 10.7981 192.496 18.52 196.763 27.4666C200.697 35.7137 207.858 46.7191 219.635 52.3147C219.718 52.3541 219.754 52.4532 219.714 52.5361C219.686 52.5959 219.626 52.631 219.564 52.631Z"
          fill="white"
        />
        <path
          opacity="0.7"
          d="M205.369 88.9993C205.28 88.9993 205.207 88.929 205.203 88.8394C205.2 88.7476 205.271 88.6705 205.363 88.667C221.349 88.0652 229.955 78.2564 234.36 70.1336C239.14 61.32 240.145 52.5403 240.155 52.4527C240.165 52.3612 240.248 52.2961 240.338 52.3056C240.429 52.3156 240.495 52.3976 240.485 52.4889C240.475 52.5771 239.463 61.4219 234.652 70.2922C230.206 78.4909 221.518 88.3916 205.376 88.9993C205.374 88.9993 205.371 88.9993 205.369 88.9993Z"
          fill="white"
        />
        <path
          opacity="0.7"
          d="M201.151 107.18C201.129 107.18 201.106 107.175 201.085 107.166C187.401 101.242 182.325 90.8826 180.476 83.235C178.474 74.9548 179.724 67.9789 179.737 67.9094C179.754 67.8192 179.842 67.7596 179.93 67.7762C180.021 67.793 180.08 67.8796 180.064 67.9698C180.051 68.0387 178.814 74.9555 180.802 83.1691C182.635 90.7389 187.664 100.994 201.217 106.861C201.301 106.897 201.34 106.995 201.303 107.079C201.276 107.142 201.215 107.18 201.151 107.18Z"
          fill="white"
        />
        <path
          opacity="0.7"
          d="M210.201 152.525C210.123 152.525 210.053 152.469 210.038 152.389C210.021 152.299 210.08 152.212 210.17 152.195C224.664 149.439 232.3 139.57 236.154 131.777C240.337 123.32 241.095 115.41 241.102 115.331C241.11 115.239 241.2 115.173 241.283 115.18C241.374 115.189 241.441 115.269 241.433 115.361C241.426 115.44 240.664 123.403 236.457 131.915C232.57 139.78 224.865 149.739 210.232 152.522C210.222 152.524 210.211 152.525 210.201 152.525Z"
          fill="white"
        />
        <path
          opacity="0.7"
          d="M204.928 178.999C204.92 178.999 204.912 178.998 204.904 178.997C191.844 177.11 184.567 167.161 180.762 159.146C176.647 150.478 175.597 142.144 175.587 142.061C175.576 141.97 175.641 141.887 175.732 141.876C175.819 141.866 175.906 141.93 175.917 142.021C175.927 142.104 176.972 150.391 181.066 159.011C184.837 166.949 192.041 176.803 204.952 178.668C205.042 178.681 205.105 178.765 205.092 178.856C205.08 178.939 205.009 178.999 204.928 178.999Z"
          fill="white"
        />
      </g>
      <path
        d="M97.5211 211.053C107.522 206.797 112.702 194.389 113.033 184.545C113.544 169.351 102.278 166.897 100.924 150.569C99.4847 133.205 111.697 129.622 109.632 113.157C107.742 98.0768 97.2419 99.0446 92.6296 81.273C87.9916 63.4023 96.7935 56.0432 89.3793 41.5382C87.9658 38.7729 82.1543 27.4034 71.9705 26.6558C63.4501 26.0302 55.7511 33.1247 52.52 39.8986C48.8663 47.5586 52.4586 51.5954 52.1062 65.1428C51.6247 83.6505 44.7192 83.8486 45.973 96.4193C47.6486 113.219 60.1369 116.722 58.6268 130.172C57.6114 139.217 51.286 139.235 47.5956 149.832C42.3221 164.975 48.7931 183.443 59.1415 195.088C60.5017 196.619 80.3185 218.375 97.5211 211.053Z"
        fill="url(#paint3_linear_10922_90677)"
      />
      <path
        d="M97.5211 211.053C107.522 206.797 112.702 194.389 113.033 184.545C113.544 169.351 102.278 166.897 100.924 150.569C99.4847 133.205 111.697 129.622 109.632 113.157C107.742 98.0768 97.2419 99.0446 92.6296 81.273C87.9916 63.4023 96.7935 56.0432 89.3793 41.5382C87.9658 38.7729 82.1543 27.4034 71.9705 26.6558C63.4501 26.0302 55.7511 33.1247 52.52 39.8986C48.8663 47.5586 52.4586 51.5954 52.1062 65.1428C51.6247 83.6505 44.7192 83.8486 45.973 96.4193C47.6486 113.219 60.1369 116.722 58.6268 130.172C57.6114 139.217 51.286 139.235 47.5956 149.832C42.3221 164.975 48.7931 183.443 59.1415 195.088C60.5017 196.619 80.3185 218.375 97.5211 211.053Z"
        fill="url(#paint4_linear_10922_90677)"
      />
      <mask
        id="mask2_10922_90677"
        maskUnits="userSpaceOnUse"
        x="45"
        y="26"
        width="69"
        height="187"
      >
        <path
          d="M97.525 211.069C107.526 206.813 112.706 194.405 113.037 184.56C113.548 169.366 102.282 166.913 100.928 150.585C99.4886 133.221 111.701 129.638 109.636 113.173C107.746 98.0924 97.2458 99.0602 92.6335 81.2886C87.9955 63.4179 96.7974 56.0588 89.3832 41.5539C87.9697 38.7885 82.1582 27.419 71.9744 26.6714C63.454 26.0458 55.755 33.1404 52.5239 39.9142C48.8702 47.5742 52.4625 51.611 52.1101 65.1584C51.6287 83.6661 44.7231 83.8643 45.9769 96.4349C47.6525 113.235 60.1408 116.737 58.6308 130.187C57.6153 139.233 51.2899 139.251 47.5995 149.848C42.326 164.99 48.797 183.459 59.1454 195.104C60.5056 196.635 80.3224 218.39 97.525 211.069Z"
          fill="white"
        />
      </mask>
      <g mask="url(#mask2_10922_90677)">
        <path
          opacity="0.7"
          d="M91.5996 216.401C91.5555 216.401 91.511 216.384 91.4786 216.349C80.0851 204.208 74.4846 191.953 74.8322 179.924C74.9974 174.209 76.4489 170.811 78.1295 166.877C79.7972 162.974 81.6872 158.55 82.9559 150.714C85.46 135.248 84.1698 121.243 79.121 109.088C76.3544 102.427 73.5053 98.9407 71.2158 96.1397C68.564 92.895 66.4692 90.3321 65.6266 84.6046C64.6468 77.9416 66.4802 73.5234 68.6032 68.4075C70.3705 64.1483 72.3737 59.3209 72.9996 52.3168C73.922 41.987 72.268 31.1504 68.0833 20.1079C68.0508 20.0221 68.094 19.9262 68.18 19.8937C68.265 19.861 68.3614 19.9045 68.3941 19.9902C72.5967 31.08 74.2575 41.9661 73.3305 52.3463C72.7001 59.4012 70.6865 64.2536 68.9101 68.5348C66.806 73.6051 64.989 77.984 65.9556 84.556C66.7846 90.1926 68.8537 92.7241 71.473 95.9292C73.7761 98.747 76.6424 102.254 79.4279 108.961C84.5005 121.174 85.7979 135.239 83.2835 150.766C82.0086 158.643 80.1102 163.087 78.435 167.007C76.7676 170.91 75.3276 174.281 75.1643 179.934C74.819 191.872 80.3893 204.047 91.7204 216.121C91.7834 216.188 91.7801 216.293 91.7129 216.356C91.6814 216.386 91.6405 216.401 91.5996 216.401Z"
          fill="white"
        />
        <path
          opacity="0.7"
          d="M66.1193 75.5138C66.0572 75.5138 65.9976 75.4788 65.9694 75.4189C65.9298 75.336 65.9651 75.2369 66.0479 75.1975C77.8285 69.6006 84.9906 58.5915 88.924 50.3415C93.1895 41.3957 94.6829 33.6808 94.6975 33.604C94.7147 33.5136 94.803 33.4545 94.8916 33.4717C94.9819 33.4888 95.0412 33.5758 95.0241 33.6659C95.0094 33.7432 93.508 41.5003 89.224 50.4846C85.2674 58.7832 78.0593 69.859 66.1907 75.4977C66.1676 75.5087 66.1433 75.5138 66.1193 75.5138Z"
          fill="white"
        />
        <path
          opacity="0.7"
          d="M80.3198 111.882C80.3179 111.882 80.3156 111.882 80.3136 111.882C64.1714 111.274 55.4832 101.374 51.037 93.175C46.2265 84.3046 45.2139 75.46 45.2041 75.3717C45.1941 75.2806 45.2599 75.1984 45.3512 75.1885C45.4415 75.1787 45.5242 75.2442 45.5346 75.3355C45.5443 75.4232 46.5521 84.212 51.3343 93.0257C55.7394 101.144 64.3448 110.948 80.326 111.55C80.4179 111.553 80.4893 111.63 80.4861 111.722C80.4824 111.812 80.4087 111.882 80.3198 111.882Z"
          fill="white"
        />
        <path
          opacity="0.7"
          d="M84.5373 130.062C84.4731 130.062 84.412 130.025 84.3847 129.962C84.3484 129.878 84.387 129.78 84.4714 129.744C98.0291 123.874 103.058 113.614 104.889 106.04C106.874 97.8275 105.637 90.9214 105.624 90.8527C105.608 90.7623 105.667 90.6758 105.758 90.659C105.845 90.6424 105.934 90.702 105.951 90.7922C105.964 90.8618 107.214 97.8376 105.212 106.118C103.363 113.765 98.2868 124.125 84.6032 130.049C84.5818 130.058 84.5594 130.062 84.5373 130.062Z"
          fill="white"
        />
        <path
          opacity="0.7"
          d="M75.4825 175.407C75.4721 175.407 75.4617 175.406 75.451 175.404C60.8187 172.622 53.1137 162.662 49.2267 154.798C45.0195 146.285 44.2577 138.323 44.2507 138.244C44.2426 138.152 44.3098 138.071 44.4012 138.063C44.4827 138.056 44.5733 138.122 44.5817 138.214C44.5888 138.292 45.3467 146.202 49.5291 154.66C53.3831 162.453 61.0193 172.322 75.5134 175.078C75.6033 175.095 75.6626 175.182 75.6455 175.272C75.6302 175.352 75.5608 175.407 75.4825 175.407Z"
          fill="white"
        />
        <path
          opacity="0.7"
          d="M80.7519 201.881C80.6707 201.881 80.5997 201.822 80.5876 201.739C80.5747 201.648 80.6376 201.564 80.7284 201.551C93.6393 199.686 100.844 189.832 104.614 181.894C108.709 173.274 109.753 164.987 109.763 164.904C109.774 164.813 109.862 164.748 109.948 164.759C110.04 164.77 110.104 164.853 110.093 164.944C110.083 165.027 109.033 173.361 104.918 182.029C101.113 190.043 93.8357 199.993 80.7759 201.88C80.7678 201.881 80.7601 201.881 80.7519 201.881Z"
          fill="white"
        />
      </g>
      <path
        d="M213.609 63.0864L163.204 5.73286C161.111 3.49047 156.838 4.00308 153.802 3.85041C150.753 3.69709 147.816 4.76718 145.654 6.82381L86.7666 62.7217C82.6098 66.6755 80.1406 72.037 80.1406 77.6242V234.529C80.1406 244.487 88.8072 251.626 99.2049 250.327L202.915 237.395C211.779 236.287 218.826 227.984 218.826 218.95V76.4705C218.826 71.4822 216.971 66.6871 213.609 63.0864ZM153.362 70.205C145.682 70.2245 139.396 64.0592 139.396 56.4341C139.396 48.8092 145.682 42.7334 153.362 42.862C160.959 42.9893 167.058 49.1534 167.058 56.6308C167.058 64.1085 160.959 70.1858 153.362 70.205Z"
        fill="url(#paint5_linear_10922_90677)"
      />
      <path
        d="M218.366 63.0973L166.965 7.81705C164.888 5.58523 162.034 4.23534 159.021 4.08442C155.992 3.93358 153.082 4.99733 150.935 7.04725L121.994 34.6566L92.6674 62.7415C88.5404 66.679 86.2656 72.0245 86.2656 77.5904V233.909C86.2656 243.83 94.8116 250.916 105.127 249.624L180.647 240.171L207.734 236.79C216.537 235.688 223.51 227.387 223.51 218.387V76.434C223.51 71.4637 221.704 66.6868 218.366 63.0973ZM158.588 42.9532C166.13 43.0769 172.184 49.2192 172.184 56.6689C172.184 64.1185 166.13 70.1756 158.588 70.195C150.968 70.2143 144.725 64.0721 144.725 56.4755C144.725 48.8789 150.968 42.8256 158.588 42.9532Z"
        fill="url(#paint6_linear_10922_90677)"
      />
      <g opacity="0.15">
        <path
          d="M153.02 127.216C152.755 144.757 141.784 153.872 129.57 153.825C116.262 153.774 105.595 143.571 105.848 126.818C106.089 110.888 116.124 99.5397 131.035 100.654C145.502 101.734 153.237 112.9 153.02 127.216ZM121.428 126.88C121.289 136.03 124.283 142.681 130.133 142.789C135.763 142.894 138.569 137.158 138.715 127.558C138.846 118.879 136.62 112.032 130.472 111.664C124.49 111.305 121.56 118.133 121.428 126.88ZM133.777 183.272L176.162 106.532C176.972 105.065 178.564 104.204 180.236 104.329C183.344 104.561 185.175 107.927 183.68 110.663L141.764 187.381C141.045 188.698 139.689 189.543 138.19 189.61L137.721 189.63C134.375 189.779 132.157 186.204 133.777 183.272ZM206.299 161.646C206.053 177.891 196.636 186.78 186.187 187.239C174.948 187.733 165.881 178.772 165.995 163.333C166.217 148.649 174.772 137.735 187.494 138.077C199.876 138.409 206.5 148.386 206.299 161.646ZM179.379 162.712C179.136 171.161 181.684 177.171 186.68 177.025C191.493 176.885 193.901 171.465 194.035 162.587C194.157 154.56 192.37 148.334 187.115 148.27C181.894 148.207 179.502 154.638 179.379 162.712Z"
          fill="url(#paint7_linear_10922_90677)"
        />
      </g>
      <path
        d="M155.067 126.403C154.802 143.944 143.831 153.06 131.617 153.013C118.309 152.962 107.642 142.758 107.895 126.005C108.136 110.076 118.171 98.7272 133.081 99.841C147.549 100.922 155.284 112.087 155.067 126.403ZM123.475 126.067C123.336 135.217 126.33 141.868 132.18 141.977C137.81 142.081 140.616 136.345 140.762 126.745C140.893 118.066 138.667 111.22 132.519 110.851C126.537 110.492 123.607 117.32 123.475 126.067ZM135.824 182.459L178.208 105.72C179.019 104.252 180.611 103.391 182.282 103.516C185.391 103.749 187.221 107.114 185.727 109.85L143.811 186.569C143.092 187.886 141.736 188.731 140.237 188.797L139.768 188.818C136.421 188.966 134.204 185.392 135.824 182.459ZM208.346 160.833C208.1 177.079 198.683 185.968 188.234 186.427C176.995 186.92 167.928 177.959 168.042 162.52C168.264 147.837 176.818 136.923 189.541 137.264C201.923 137.597 208.546 147.574 208.346 160.833ZM181.426 161.899C181.183 170.348 183.731 176.359 188.726 176.213C193.54 176.072 195.948 170.652 196.082 161.774C196.203 153.747 194.416 147.522 189.162 147.458C183.941 147.394 181.548 153.825 181.426 161.899Z"
        fill="white"
      />
      <path
        opacity="0.35"
        d="M180.592 240.17L105.127 249.623C94.8116 250.915 86.2656 243.829 86.2656 233.908V77.5901C86.2656 72.0242 88.538 66.6787 92.665 62.7412L122.045 34.6562C116.486 52.5183 118.018 65.5609 121.12 74.7627C130.937 103.888 159.572 105.431 166.979 134.893C172.959 158.681 157.245 169.511 159.345 195.786C160.343 208.322 165.364 223.701 180.592 240.17Z"
        fill="white"
      />
      <path
        d="M85.6491 152.42C86.2578 151.955 86.8669 151.489 87.4757 151.023C88.0085 151.175 96.7574 153.804 98.4893 161.5C98.7277 162.558 99.6056 166.46 97.4686 168.968C93.8863 173.172 83.4907 171.516 78.611 165.637C74.7766 161.017 74.3003 153.731 76.5157 152.367C79.1968 150.715 87.1892 156.892 87.798 157.363C89.0197 158.307 90.1291 159.312 90.3231 159.136C90.6531 158.836 88.0289 155.405 85.6491 152.42Z"
        fill="url(#paint8_linear_10922_90677)"
      />
      <path
        d="M18.2805 206.887C18.2805 206.887 18.7465 205.677 18.0165 205.044C17.2866 204.411 13.2487 202.58 11.2222 202.618C9.19588 202.656 10.8287 204.217 11.9855 205.101C13.1423 205.985 15.8407 207.837 16.5353 207.994C17.2298 208.15 18.2805 206.887 18.2805 206.887Z"
        fill="url(#paint9_linear_10922_90677)"
      />
      <path
        d="M21.8513 209.038C20.675 208.122 19.6483 207.407 18.8728 206.891C17.157 205.75 16.3922 205.398 15.6262 205.158C14.9585 204.95 13.4447 204.562 13.303 204.876C13.1589 205.195 14.5616 205.944 18.0067 208.559C18.5068 208.938 20.0952 210.151 20.0952 210.151L21.8513 209.038Z"
        fill="url(#paint10_linear_10922_90677)"
      />
      <path
        d="M73.136 263.188C73.136 263.188 72.6683 264.397 73.3973 265.031C74.1264 265.665 78.1616 267.503 80.1881 267.467C82.2144 267.432 80.5839 265.868 79.4284 264.983C78.273 264.097 75.5772 262.242 74.8827 262.084C74.1886 261.926 73.136 263.188 73.136 263.188Z"
        fill="url(#paint11_linear_10922_90677)"
      />
      <path
        d="M73.4262 257.852C73.3405 259.393 73.5008 260.644 73.6703 261.515C73.912 262.758 74.0586 263.462 74.6482 264.086C75.6896 265.188 77.513 265.405 77.7773 264.962C78.0771 264.459 76.1477 263.477 75.5076 261.119C75.2273 260.086 75.2926 259.152 75.4029 258.495L73.4262 257.852Z"
        fill="url(#paint12_linear_10922_90677)"
      />
      <path
        d="M80.3673 194.978C83.0982 197.852 82.5016 201.96 81.6462 209.323C80.9287 215.5 79.9515 224.635 79.0322 236.198C78.1978 244.265 77.3634 252.331 76.5289 260.397C75.1382 260.397 73.7475 260.397 72.3568 260.397C70.6513 256.775 68.6199 251.229 68.5184 244.376C68.4342 238.699 69.7608 237.954 70.0168 231.525C70.1577 227.99 69.8444 226.008 67.1833 210.665C65.0663 198.459 64.6498 196.168 66.3489 194.31C69.3462 191.032 76.8949 191.322 80.3673 194.978Z"
        fill="url(#paint13_linear_10922_90677)"
      />
      <path
        opacity="0.4"
        d="M72.023 251.189C72.7408 248.939 74.6477 246.639 74.7766 242.177C74.9286 236.913 72.4043 235.599 72.7739 230.662C73.1291 225.918 75.577 225.573 76.2786 220.899C77.0935 215.471 74.0739 214.051 73.0243 207.632C72.0669 201.776 73.4532 196.069 74.8965 192.254C71.6558 191.663 68.1664 192.331 66.3489 194.319C64.6498 196.177 65.0664 198.468 67.1833 210.673C69.8444 226.016 70.1576 227.998 70.0168 231.534C69.7606 237.963 68.4342 238.708 68.5184 244.384C68.6199 251.237 70.6512 256.783 72.3567 260.405C72.8171 260.405 73.2772 260.405 73.7375 260.405C71.5077 256.351 71.3194 253.395 72.023 251.189Z"
        fill="url(#paint14_linear_10922_90677)"
      />
      <path
        d="M17.5703 209.724C23.4195 217.783 34.6032 231.097 44.2733 228.84C49.3866 227.646 51.2417 222.76 66.2701 202.123C69.8842 197.16 72.9615 193.069 75.1458 190.198C69.3048 188.752 63.4638 187.306 57.6228 185.859C53.68 192.364 51.0875 197.872 49.4821 201.59C45.6444 210.48 44.2605 216.532 40.7674 216.9C39.0597 217.08 37.953 215.785 35.5939 213.896C32.5053 211.423 27.7218 208.294 20.5742 205.886C19.5729 207.165 18.5716 208.444 17.5703 209.724Z"
        fill="url(#paint15_linear_10922_90677)"
      />
      <path
        d="M76.3745 141.793C75.0585 139.675 73.029 138.842 70.7614 137.947C67.8212 136.788 66.4951 137.024 64.3105 136.47C58.9057 135.099 58.8012 131.567 53.95 129.136C47.7494 126.028 44.7216 130.196 39.5769 127.454C33.8011 124.375 35.8433 118.177 30.7414 114.067C23.6597 108.363 7.10234 110.137 1.89187 119.975C-1.11775 125.656 -0.551175 134.423 3.69637 139.344C6.17224 142.213 9.72527 143.738 9.54777 146.296C9.42139 148.116 7.26815 148.364 6.00605 150.951C4.37867 154.285 5.88665 158.113 6.13023 158.731C8.39055 164.47 18.6999 168.001 27.7814 166.778C44.158 164.57 51.4013 147.592 61.8314 150.815C63.7496 151.408 66.5231 153.062 70.3929 152.455C71.558 152.273 75.6852 151.626 77.1484 148.207C78.4366 145.197 76.6027 142.16 76.3745 141.793Z"
        fill="url(#paint16_linear_10922_90677)"
      />
      <path
        d="M57.8506 150.573C62.3297 150.556 67.8745 150.605 73.5413 151.203C85.725 152.489 85.2458 158.551 83.0396 164.078C80.7884 169.717 80.8666 174.697 80.9119 176.469C80.9848 179.323 81.5034 181.611 82.541 186.188C84.3432 194.138 85.6855 195.964 84.4166 197.997C82.566 200.962 77.3801 200.815 76.4707 200.772C71.8646 200.55 70.8873 197.847 67.0037 197.419C62.4915 196.922 61.4484 200.311 55.1746 202.591C47.7694 205.282 38.236 204.57 33.8079 199.612C32.0981 197.698 31.0009 195.053 31.7362 194.221C32.737 193.087 36.2187 196.349 39.9253 195.055C42.3806 194.198 42.1589 192.311 45.0992 190.469C48.6378 188.253 50.7195 189.884 53.1189 188.454C56.8615 186.222 56.0565 179.714 56.3594 169C56.4847 164.565 56.8329 158.252 57.8506 150.573Z"
        fill="url(#paint17_linear_10922_90677)"
      />
      <path
        d="M57.8513 150.569C51.353 150.886 49.0298 157.65 42.2457 158.985C38.1353 159.793 32.0043 158.684 23.2007 150.133C21.9528 150.71 20.705 151.287 19.457 151.865C20.7394 159.543 24.3024 163.851 26.0514 165.665C36.0434 176.031 54.9944 175.713 65.256 166.827C68.4762 164.038 70.2916 160.881 71.278 158.806C68.0346 154.773 63.3139 150.303 57.8513 150.569Z"
        fill="url(#paint18_linear_10922_90677)"
      />
      <path
        d="M72.0762 145.56C71.6705 145.269 71.1003 145.459 70.9467 145.934C70.5212 147.25 69.6419 149.489 68.4434 150.049C66.7177 150.854 64.1193 150.5 63.7909 150.82C63.4638 151.138 71.5394 155.329 76.9199 153.424C76.9577 153.411 76.9944 153.394 77.0297 153.375L77.3361 153.21C77.9435 152.883 77.8062 151.976 77.1294 151.842C76.0913 151.637 73.3723 150.856 72.6882 149.67C72.6096 149.534 72.5874 148.464 72.6072 148.308L72.8278 146.574C72.8619 146.307 72.7466 146.042 72.5273 145.884L72.0762 145.56Z"
        fill="url(#paint19_linear_10922_90677)"
      />
      <path
        d="M70.8065 146.466C70.8065 146.466 71.6824 148.029 73.3967 147.626C74.932 147.265 74.5074 143.361 73.3922 142.788C73.0203 142.597 72.298 142.576 71.7845 142.817C71.4236 142.987 70.3932 143.994 70.7584 145.305C70.3998 145.153 70.0608 145.211 69.957 145.386C69.8252 145.607 70.102 145.962 70.1646 146.043C70.382 146.322 70.6718 146.427 70.8065 146.466Z"
        fill="url(#paint20_linear_10922_90677)"
      />
      <path
        d="M22.1502 150.613L21.5373 149.405C21.5373 149.405 24.6675 144.285 22.102 143.463C19.5364 142.64 20.2596 144.105 20.5505 144.803C20.8414 145.502 20.3729 147.779 19.9272 148.475C19.4815 149.171 20.2567 151.489 20.2567 151.489L22.1502 150.613Z"
        fill="url(#paint21_linear_10922_90677)"
      />
      <path
        opacity="0.3"
        d="M44.3188 199.198C45.9372 198.096 44.8233 195.936 46.6552 194.191C48.3317 192.594 50.1664 193.544 53.1637 192.689C56.7667 191.661 59.558 188.736 60.8404 186.181C61.7546 184.359 61.6812 183.165 60.8404 173.831C60.0396 164.942 59.813 162.771 58.6709 162.483C56.5925 161.959 54.7312 168.49 50.6604 168.491C48.3612 168.491 48.0496 166.408 45.1532 165.32C40.2371 163.473 36.7233 167.817 31.4685 167.656C30.1253 167.615 28.4961 167.265 26.6367 166.219C34.2095 173.527 46.4084 175.123 56.2979 171.813C56.1639 180.847 56.5155 186.417 53.1152 188.444C50.7159 189.875 48.6342 188.244 45.0956 190.46C42.1552 192.301 42.377 194.188 39.9217 195.046C36.2152 196.339 32.7334 193.078 31.7327 194.211C31.0659 194.966 31.9123 197.207 33.3499 199.046C34.1944 198.696 35.1263 198.443 36.1414 198.363C40.0203 198.061 42.4091 200.497 44.3188 199.198Z"
        fill="url(#paint22_linear_10922_90677)"
      />
      <path
        d="M90.4655 131.556L90.0078 130.366L91.1949 129.192C91.4597 128.93 91.8634 128.87 92.193 129.044C93.9384 129.964 99.205 133.235 100.775 139.884C100.858 140.233 100.713 140.597 100.413 140.794C99.8685 141.152 99.2268 141.457 99.2268 141.457L90.4655 131.556Z"
        fill="url(#paint23_linear_10922_90677)"
      />
      <path
        d="M84.5596 145.942L85.2661 149.834C85.2661 149.834 85.304 150.96 85.4863 151.396C85.0428 151.979 83.9322 152.259 83.9322 152.259L81.7188 147.865L84.4293 145.93L84.5596 145.942Z"
        fill="url(#paint24_linear_10922_90677)"
      />
      <path
        d="M87.061 151.343L86.4291 149.761C86.4291 149.761 85.8512 148.512 84.2212 148.299C82.5912 148.086 82.6094 148.966 82.6094 148.966L83.6725 149.28C83.6725 149.28 84.3605 149.479 84.8322 150.475C85.4922 151.49 86.2005 152.001 86.2005 152.001L87.061 151.343Z"
        fill="url(#paint25_linear_10922_90677)"
      />
      <path
        d="M78.1133 146.738C78.1133 146.738 88.0027 137.264 90.0068 130.367C97.0385 132.307 99.2258 141.458 99.2258 141.458C99.2258 141.458 85.0631 146.075 80.4228 149.685C78.7625 149.319 78.1133 146.738 78.1133 146.738Z"
        fill="url(#paint26_linear_10922_90677)"
      />
      <path
        d="M104.792 140.998C104.396 140.858 104.086 140.512 104.013 140.068C101.979 127.83 93.4328 125.881 93.3494 125.863C92.7041 125.727 92.2919 125.092 92.4285 124.447C92.5653 123.802 93.1993 123.39 93.8446 123.526C94.2628 123.614 104.072 125.848 106.369 139.677C106.477 140.327 106.037 140.943 105.387 141.051C105.18 141.085 104.976 141.064 104.792 140.998Z"
        fill="url(#paint27_linear_10922_90677)"
      />
      <path
        d="M232.543 201.574C232.183 201.574 231.876 201.301 231.841 200.935C231.223 194.449 229.108 188.286 225.886 183.582C223.032 179.415 219.634 176.928 216.795 176.928C216.791 176.928 216.789 176.928 216.785 176.928C206.445 176.948 204.282 200.689 204.261 200.929C204.228 201.317 203.887 201.605 203.497 201.572C203.109 201.538 202.821 201.196 202.854 200.808C202.943 199.776 205.157 175.538 216.783 175.516C216.787 175.516 216.791 175.516 216.795 175.516C220.149 175.516 223.887 178.164 227.051 182.784C230.406 187.683 232.606 194.081 233.246 200.801C233.283 201.189 232.999 201.534 232.61 201.571C232.588 201.573 232.565 201.574 232.543 201.574Z"
        fill="url(#paint28_linear_10922_90677)"
      />
      <path
        d="M189.465 250.427L203.077 257.319L211.325 232.009L197.735 198.078L193.882 199.023L188.035 247.754C187.902 248.857 188.474 249.925 189.465 250.427Z"
        fill="url(#paint29_linear_10922_90677)"
      />
      <path
        opacity="0.52"
        d="M211.325 232.009L197.735 198.078L195.462 198.635C195.147 203.166 195.285 206.894 195.5 209.609C196.411 221.161 199.436 224.376 197.97 232.435C196.752 239.137 194.09 240.046 194.323 244.555C194.576 249.465 198.001 253.577 202.073 256.81L203.077 257.319L211.325 232.009Z"
        fill="url(#paint30_linear_10922_90677)"
      />
      <path
        d="M197.738 198.078H248.493L265.291 252.306L203.08 257.319L197.738 198.078Z"
        fill="url(#paint31_linear_10922_90677)"
      />
      <path
        d="M213.456 202.726C213.136 202.726 212.846 202.506 212.77 202.181C212.625 201.566 209.291 187.035 213.993 179.904C215.34 177.86 217.223 176.612 219.589 176.195C231.744 174.053 239.227 200.16 239.54 201.272C239.645 201.647 239.426 202.037 239.051 202.143C238.675 202.248 238.286 202.029 238.18 201.654C238.107 201.394 230.741 175.66 219.834 177.586C217.838 177.938 216.313 178.95 215.171 180.681C210.801 187.31 214.11 201.713 214.144 201.858C214.233 202.238 213.998 202.618 213.618 202.707C213.564 202.72 213.51 202.726 213.456 202.726Z"
        fill="url(#paint32_linear_10922_90677)"
      />
      <g opacity="0.3">
        <path
          d="M248.482 198.078H223.303C222.061 199.341 221.18 200.797 221.096 202.43C220.7 210.103 238.338 212.623 240.039 223.139C241.266 230.724 233.716 239.477 226.979 243.376C219.881 247.485 215.071 245.404 210.271 249.966C208.161 251.97 206.877 254.476 206.113 257.073L265.28 252.306L248.482 198.078Z"
          fill="url(#paint33_linear_10922_90677)"
        />
        <path
          d="M233.691 221.654L225.39 216.857C223.602 215.822 221.367 217.114 221.367 219.18V228.485C221.367 230.545 223.599 231.834 225.384 230.803L233.694 225.999C235.364 225.033 235.364 222.621 233.694 221.654H233.691Z"
          fill="#7181FF"
        />
        <path
          d="M220.773 223.812C220.773 223.812 220.791 223.812 220.8 223.806C220.791 223.806 220.782 223.809 220.773 223.812ZM221.338 221.977C221.338 221.977 221.338 221.985 221.341 221.985V221.98C221.341 221.98 221.338 221.98 221.338 221.977Z"
          fill="#E9EBFF"
        />
        <path
          d="M237.482 228.329C237.473 228.188 237.444 228.049 237.399 227.91C237.352 227.774 237.296 227.641 237.225 227.514C237.124 227.33 237.015 227.165 236.897 227.011C236.69 226.745 236.456 226.485 236.199 226.237C235.717 225.773 235.209 225.338 234.674 224.936L233.808 224.3L232.856 223.644L233.409 223.269L233.66 223.094L234.547 222.45H234.55C234.887 222.184 235.159 221.962 235.366 221.785C235.632 221.563 235.907 221.306 236.19 221.016C236.43 220.777 236.625 220.549 236.779 220.34C236.906 220.165 237.012 219.988 237.095 219.813C237.172 219.657 237.225 219.491 237.254 219.317C237.287 219.136 237.287 218.965 237.254 218.802C237.21 218.566 237.107 218.356 236.947 218.176C236.861 218.075 236.758 217.987 236.64 217.913C236.521 217.839 236.397 217.783 236.267 217.741C235.983 217.656 235.688 217.614 235.38 217.623C234.904 217.635 234.437 217.691 233.976 217.789C233.149 217.969 232.336 218.199 231.538 218.48C230.875 218.711 229.519 219.243 229.533 219.252C230.204 219.633 230.864 220.029 231.535 220.41C231.535 220.41 232.735 220.003 233.22 219.855C233.586 219.751 233.959 219.657 234.331 219.574C234.529 219.533 234.783 219.494 235.091 219.456C235.111 219.456 235.123 219.459 235.126 219.468C234.969 219.648 234.807 219.819 234.632 219.982C234.142 220.44 233.624 220.866 233.078 221.259C233.069 221.271 233.051 221.285 233.024 221.306C232.548 221.643 232.176 221.903 231.904 222.086L231.638 222.264L231.144 222.586C231.144 222.586 231.118 222.58 231.103 222.571C230.586 222.273 229.997 221.942 229.335 221.581C228.552 221.167 227.76 220.768 226.962 220.381L226.764 220.295L226.163 220.014L225.951 219.923L225.637 219.784C225.723 218.933 225.853 218.09 226.022 217.251C226.122 216.722 226.264 216.186 226.444 215.646C226.498 215.483 226.554 215.341 226.61 215.214C226.616 215.217 226.622 215.217 226.622 215.223C226.802 215.725 226.941 216.24 227.041 216.766L227.234 217.928C227.234 217.928 229.211 219.071 229.22 219.071C229.17 218.516 229.099 217.933 229.013 217.381C228.91 216.633 228.753 215.894 228.546 215.167C228.428 214.75 228.262 214.351 228.049 213.97C227.955 213.801 227.837 213.638 227.692 213.482C227.532 213.31 227.349 213.183 227.142 213.101C226.973 213.033 226.799 213 226.622 213C226.344 213 226.087 213.08 225.847 213.239C225.664 213.361 225.516 213.497 225.401 213.647C225.153 213.972 224.954 214.342 224.804 214.753C224.603 215.303 224.449 215.811 224.346 216.272C224.322 216.367 224.304 216.444 224.286 216.497C224.109 217.336 223.967 218.179 223.858 219.027C223.858 219.033 223.855 219.039 223.852 219.039L223.846 219.045L223.086 218.755L222.658 218.604C222.276 218.471 221.892 218.344 221.505 218.229C221.064 218.096 220.618 217.981 220.169 217.877C219.728 217.777 219.282 217.706 218.833 217.664C218.572 217.641 218.3 217.638 218.02 217.659C217.762 217.676 217.523 217.732 217.292 217.821C217.174 217.868 217.068 217.928 216.97 217.993C216.864 218.066 216.772 218.146 216.695 218.235C216.432 218.542 216.326 218.906 216.376 219.323C216.403 219.553 216.468 219.769 216.571 219.973C216.663 220.159 216.769 220.334 216.893 220.496C217.097 220.771 217.319 221.028 217.561 221.271C218.064 221.77 218.599 222.228 219.17 222.654L219.172 222.657C219.693 223.053 220.225 223.431 220.772 223.792C220.772 223.792 220.789 223.783 220.798 223.783C220.789 223.786 220.781 223.789 220.772 223.792C220.781 223.804 220.778 223.81 220.772 223.816C220.781 223.816 220.789 223.81 220.798 223.81C220.789 223.813 220.781 223.816 220.772 223.819L220.769 223.816C220.325 224.102 219.832 224.439 219.288 224.833L218.593 225.353C218.052 225.764 217.541 226.213 217.062 226.698C216.808 226.952 216.58 227.23 216.382 227.528C216.27 227.694 216.175 227.88 216.101 228.087C216.027 228.288 215.995 228.489 216.001 228.69C216.01 228.87 216.048 229.039 216.122 229.198C216.273 229.524 216.527 229.76 216.887 229.902C217.088 229.982 217.278 230.029 217.455 230.047C217.816 230.082 218.188 230.073 218.572 230.023C218.694 230.005 218.868 229.979 219.099 229.937C219.374 229.887 219.631 229.834 219.867 229.772C220.346 229.648 220.881 229.494 221.466 229.314C222.205 229.054 222.936 228.782 223.663 228.495L223.728 229.201C223.748 229.184 223.76 229.166 223.76 229.154C223.76 229.166 223.751 229.184 223.731 229.201L223.76 229.562L223.781 229.686C223.834 230.177 223.902 230.665 223.988 231.149C224.029 231.38 224.088 231.673 224.168 232.03C224.269 232.491 224.396 232.923 224.541 233.328C224.653 233.626 224.795 233.913 224.966 234.182C225.067 234.339 225.185 234.478 225.321 234.605C225.478 234.75 225.655 234.856 225.856 234.924C226.19 235.036 226.515 235.025 226.837 234.886C227.03 234.806 227.198 234.691 227.346 234.543C227.494 234.389 227.618 234.232 227.715 234.073C227.899 233.768 228.052 233.437 228.179 233.074C228.425 232.367 228.614 231.649 228.75 230.913C228.895 230.177 229.004 229.402 229.09 228.658L227.062 229.831L226.944 230.552L226.716 231.569C226.61 231.983 226.477 232.388 226.317 232.784C226.267 232.683 226.223 232.571 226.184 232.438C225.995 231.809 225.856 231.182 225.764 230.558L225.623 229.574L225.575 229.13L225.507 228.433L225.448 227.726L226.728 227.12H226.731C227.597 226.692 228.457 226.245 229.309 225.784L230.586 225.057L230.751 224.96L231.124 224.735H231.136C231.136 224.735 231.147 224.735 231.153 224.738C231.342 224.853 231.532 224.974 231.715 225.096C231.854 225.184 231.993 225.276 232.132 225.371C232.241 225.444 232.35 225.518 232.46 225.595C232.761 225.802 233.057 226.018 233.353 226.237C233.648 226.449 233.932 226.674 234.21 226.911C234.372 227.049 234.505 227.165 234.609 227.259C234.839 227.466 235.055 227.682 235.262 227.913C235.327 227.987 235.389 228.063 235.445 228.143C235.005 228.125 234.573 228.066 234.145 227.966C234.024 227.939 233.902 227.91 233.778 227.883C233.054 227.697 231.594 227.212 231.594 227.212L229.536 228.4L231.777 229.195C232.377 229.391 232.986 229.559 233.601 229.704C234.038 229.807 234.485 229.881 234.931 229.929C235.236 229.961 235.537 229.964 235.839 229.943C236.06 229.926 236.273 229.881 236.48 229.807C236.654 229.745 236.811 229.66 236.944 229.556C237.337 229.252 237.518 228.844 237.479 228.332L237.482 228.329ZM223.633 221.472L223.592 222.134C223.592 222.184 223.589 222.261 223.586 222.358C223.544 223.145 223.527 223.966 223.527 224.824V225.453C223.533 225.728 223.539 226.003 223.544 226.281C223.544 226.361 223.55 226.441 223.559 226.523C223.553 226.547 223.536 226.565 223.512 226.574C223.488 226.579 223.476 226.582 223.476 226.582C222.779 226.884 222.069 227.159 221.351 227.407C220.562 227.703 219.746 227.939 218.892 228.122C218.629 228.182 218.38 228.217 218.144 228.232C218.3 228.046 218.487 227.853 218.702 227.655C218.992 227.389 219.258 227.159 219.504 226.964C220.089 226.497 221.36 225.604 221.366 225.598V221.968C221.366 221.968 220.766 221.543 220.476 221.339C220.151 221.108 219.841 220.86 219.539 220.6C219.199 220.307 218.877 219.994 218.575 219.66C218.534 219.615 218.481 219.544 218.416 219.453C218.803 219.471 219.202 219.527 219.616 219.615C220.234 219.748 220.819 219.905 221.369 220.091C221.783 220.221 222.194 220.36 222.601 220.511L223.074 220.685L223.675 220.922L223.636 221.472H223.633ZM221.339 221.977L221.342 221.98V221.986C221.342 221.986 221.339 221.98 221.339 221.977ZM228.975 223.878H228.972L228.874 223.931L228.815 223.969H228.812L227.508 224.673L226.707 225.081L225.889 225.486L225.389 225.728L225.38 225.35V224.383C225.38 224.011 225.386 223.635 225.404 223.263L225.469 221.729V221.702L225.977 221.933H225.983L226.447 222.154L226.775 222.317L226.917 222.391L227.568 222.713H227.571C228.153 223.009 228.726 223.316 229.297 223.635C229.297 223.638 229.306 223.641 229.323 223.644C229.332 223.65 229.341 223.656 229.344 223.668L228.978 223.878H228.975Z"
          fill="#E9EBFF"
        />
        <path
          d="M220.8 223.805C220.8 223.805 220.782 223.811 220.773 223.814C220.773 223.814 220.791 223.805 220.8 223.805Z"
          fill="#E9EBFF"
        />
        <path
          d="M221.343 221.98V221.986C221.343 221.986 221.34 221.98 221.34 221.977C221.34 221.98 221.343 221.98 221.343 221.98Z"
          fill="#E9EBFF"
        />
        <path
          d="M220.8 223.805C220.8 223.805 220.782 223.811 220.773 223.814C220.773 223.814 220.791 223.805 220.8 223.805Z"
          fill="#E9EBFF"
        />
        <path
          d="M233.821 227.964C233.821 227.964 233.803 227.976 233.797 227.985C233.803 227.976 233.812 227.967 233.821 227.961V227.964Z"
          fill="#E9EBFF"
        />
        <path
          d="M233.797 227.985C233.797 227.985 233.812 227.967 233.821 227.961C233.821 227.961 233.803 227.976 233.797 227.985Z"
          fill="#E9EBFF"
        />
      </g>
      <path
        d="M213.461 204.813C214.551 204.813 215.434 203.93 215.434 202.84C215.434 201.751 214.551 200.867 213.461 200.867C212.372 200.867 211.488 201.751 211.488 202.84C211.488 203.93 212.372 204.813 213.461 204.813Z"
        fill="url(#paint34_linear_10922_90677)"
      />
      <path
        d="M239.192 204.633C240.281 204.633 241.165 203.75 241.165 202.66C241.165 201.571 240.281 200.688 239.192 200.688C238.102 200.688 237.219 201.571 237.219 202.66C237.219 203.75 238.102 204.633 239.192 204.633Z"
        fill="url(#paint35_linear_10922_90677)"
      />
      <defs>
        <linearGradient
          id="paint0_linear_10922_90677"
          x1="250.3"
          y1="114.561"
          x2="159.66"
          y2="318.19"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset="0.0036" stopColor="#98A1E2" />
          <stop offset="1" stopColor="#6274FF" />
        </linearGradient>
        <linearGradient
          id="paint1_linear_10922_90677"
          x1="259.98"
          y1="-26.5902"
          x2="224.719"
          y2="65.3403"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#98A1E2" />
          <stop offset="0.9964" stopColor="#6274FF" />
        </linearGradient>
        <linearGradient
          id="paint2_linear_10922_90677"
          x1="259.98"
          y1="-26.5902"
          x2="224.719"
          y2="65.3403"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#98A1E2" />
          <stop offset="0.9964" stopColor="#6274FF" />
        </linearGradient>
        <linearGradient
          id="paint3_linear_10922_90677"
          x1="25.711"
          y1="-3.71518"
          x2="60.9721"
          y2="88.2153"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#98A1E2" />
          <stop offset="0.9964" stopColor="#6274FF" />
        </linearGradient>
        <linearGradient
          id="paint4_linear_10922_90677"
          x1="125.508"
          y1="3.37297"
          x2="51.5144"
          y2="196.285"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset="0.0036" stopColor="#98A1E2" />
          <stop offset="1" stopColor="#6274FF" />
        </linearGradient>
        <linearGradient
          id="paint5_linear_10922_90677"
          x1="137.522"
          y1="463.905"
          x2="189.969"
          y2="-920.077"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset="0.0036" stopColor="#7181FF" />
          <stop offset="1" stopColor="#C0C7FF" />
        </linearGradient>
        <linearGradient
          id="paint6_linear_10922_90677"
          x1="117.35"
          y1="1138.53"
          x2="169.578"
          y2="-239.693"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset="0.0036" stopColor="#7181FF" />
          <stop offset="1" stopColor="#7181FF" />
        </linearGradient>
        <linearGradient
          id="paint7_linear_10922_90677"
          x1="105.578"
          y1="144.687"
          x2="206.532"
          y2="146.211"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#FF9085" />
          <stop offset="1" stopColor="#FB6FBB" />
        </linearGradient>
        <linearGradient
          id="paint8_linear_10922_90677"
          x1="46.295"
          y1="320.145"
          x2="85.1623"
          y2="167.705"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#AA80F9" />
          <stop offset="0.9964" stopColor="#6165D7" />
        </linearGradient>
        <linearGradient
          id="paint9_linear_10922_90677"
          x1="22.3558"
          y1="215.667"
          x2="4.57298"
          y2="190.783"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#1A1E3D" />
          <stop offset="1" stopColor="#1A1E3D" />
        </linearGradient>
        <linearGradient
          id="paint10_linear_10922_90677"
          x1="14.0926"
          y1="201.775"
          x2="36.9299"
          y2="236.117"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#FFC444" />
          <stop offset="0.9964" stopColor="#F36F56" />
        </linearGradient>
        <linearGradient
          id="paint11_linear_10922_90677"
          x1="69.0733"
          y1="254.402"
          x2="86.8203"
          y2="279.312"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#444B8C" />
          <stop offset="1" stopColor="#444B8C" />
        </linearGradient>
        <linearGradient
          id="paint12_linear_10922_90677"
          x1="74.2023"
          y1="266.059"
          x2="82.9902"
          y2="236.92"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#FFC444" />
          <stop offset="0.9964" stopColor="#F36F56" />
        </linearGradient>
        <linearGradient
          id="paint13_linear_10922_90677"
          x1="85.3764"
          y1="258.951"
          x2="71.6083"
          y2="210.638"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#444B8C" />
          <stop offset="0.9964" stopColor="#1A1E3D" />
        </linearGradient>
        <linearGradient
          id="paint14_linear_10922_90677"
          x1="82.8385"
          y1="259.683"
          x2="69.0704"
          y2="211.37"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#444B8C" />
          <stop offset="0.9964" stopColor="#26264F" />
        </linearGradient>
        <linearGradient
          id="paint15_linear_10922_90677"
          x1="59.611"
          y1="224.195"
          x2="40.7845"
          y2="189.769"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#444B8C" />
          <stop offset="0.9964" stopColor="#1A1E3D" />
        </linearGradient>
        <linearGradient
          id="paint16_linear_10922_90677"
          x1="-36.5548"
          y1="180.687"
          x2="58.6665"
          y2="121.693"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#444B8C" />
          <stop offset="0.9964" stopColor="#1A1E3D" />
        </linearGradient>
        <linearGradient
          id="paint17_linear_10922_90677"
          x1="27.6967"
          y1="315.406"
          x2="66.564"
          y2="162.966"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#BCC4FF" />
          <stop offset="0.9964" stopColor="#6165D7" />
        </linearGradient>
        <linearGradient
          id="paint18_linear_10922_90677"
          x1="5.96826"
          y1="309.862"
          x2="44.8355"
          y2="157.422"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#AA80F9" />
          <stop offset="0.9964" stopColor="#6165D7" />
        </linearGradient>
        <linearGradient
          id="paint19_linear_10922_90677"
          x1="65.8486"
          y1="163.755"
          x2="75.087"
          y2="141.184"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#FFC444" />
          <stop offset="0.9964" stopColor="#F36F56" />
        </linearGradient>
        <linearGradient
          id="paint20_linear_10922_90677"
          x1="68.8626"
          y1="141.304"
          x2="87.7719"
          y2="161.281"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#FFC444" />
          <stop offset="0.9964" stopColor="#F36F56" />
        </linearGradient>
        <linearGradient
          id="paint21_linear_10922_90677"
          x1="21.9106"
          y1="138.673"
          x2="20.1914"
          y2="170.156"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#FFC444" />
          <stop offset="0.9964" stopColor="#F36F56" />
        </linearGradient>
        <linearGradient
          id="paint22_linear_10922_90677"
          x1="26.6368"
          y1="181.018"
          x2="61.4989"
          y2="181.018"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#AA80F9" />
          <stop offset="0.9964" stopColor="#6165D7" />
        </linearGradient>
        <linearGradient
          id="paint23_linear_10922_90677"
          x1="99.2603"
          y1="131.411"
          x2="90.4432"
          y2="140.521"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#1A1E3D" />
          <stop offset="1" stopColor="#1A1E3D" />
        </linearGradient>
        <linearGradient
          id="paint24_linear_10922_90677"
          x1="87.7683"
          y1="145.333"
          x2="78.4603"
          y2="154.949"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#AB316D" />
          <stop offset="1" stopColor="#792D3D" />
        </linearGradient>
        <linearGradient
          id="paint25_linear_10922_90677"
          x1="83.7751"
          y1="148.237"
          x2="86.0882"
          y2="151.699"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#FFC444" />
          <stop offset="0.9964" stopColor="#F36F56" />
        </linearGradient>
        <linearGradient
          id="paint26_linear_10922_90677"
          x1="89.4226"
          y1="131.179"
          x2="87.175"
          y2="169.738"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#444B8C" />
          <stop offset="0.9964" stopColor="#26264F" />
        </linearGradient>
        <linearGradient
          id="paint27_linear_10922_90677"
          x1="97.4532"
          y1="133.448"
          x2="102.837"
          y2="130.219"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#1A1E3D" />
          <stop offset="1" stopColor="#1A1E3D" />
        </linearGradient>
        <linearGradient
          id="paint28_linear_10922_90677"
          x1="199.542"
          y1="184.384"
          x2="205.719"
          y2="186.678"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#4654BB" />
          <stop offset="1" stopColor="#1A1E3D" />
        </linearGradient>
        <linearGradient
          id="paint29_linear_10922_90677"
          x1="182.241"
          y1="205.605"
          x2="199.448"
          y2="234.46"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#A7B1FF" />
          <stop offset="1" stopColor="#586BFF" />
        </linearGradient>
        <linearGradient
          id="paint30_linear_10922_90677"
          x1="184.902"
          y1="204.018"
          x2="202.109"
          y2="232.874"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#A7B1FF" />
          <stop offset="1" stopColor="#586BFF" />
        </linearGradient>
        <linearGradient
          id="paint31_linear_10922_90677"
          x1="212.199"
          y1="217.229"
          x2="260.644"
          y2="254.556"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#A7B1FF" />
          <stop offset="1" stopColor="#586BFF" />
        </linearGradient>
        <linearGradient
          id="paint32_linear_10922_90677"
          x1="221.713"
          y1="173.729"
          x2="226.655"
          y2="205.233"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#1A1E3D" />
          <stop offset="1" stopColor="#4654BB" />
        </linearGradient>
        <linearGradient
          id="paint33_linear_10922_90677"
          x1="212.814"
          y1="216.416"
          x2="261.259"
          y2="253.743"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#A7B1FF" />
          <stop offset="1" stopColor="#586BFF" />
        </linearGradient>
        <linearGradient
          id="paint34_linear_10922_90677"
          x1="210.799"
          y1="201.852"
          x2="211.595"
          y2="202.147"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#4654BB" />
          <stop offset="1" stopColor="#1A1E3D" />
        </linearGradient>
        <linearGradient
          id="paint35_linear_10922_90677"
          x1="236.53"
          y1="201.672"
          x2="237.325"
          y2="201.967"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#4654BB" />
          <stop offset="1" stopColor="#1A1E3D" />
        </linearGradient>
      </defs>
    </svg>
  )
}

export default PricingIllustration
